import React from 'react';
import styles from './SocialNetworkItem.module.scss';


export default function SocialNetworkItem() {
  return (
    <div className={styles.container}>
      <div className={styles.item}></div>
    </div>
  );
}



